// ezp_industry.label_config carries per-industry terminology overrides
// (e.g. Car Service -> "Job Card", Healthcare -> "Appointment") - sourced
// from ezpMyProfile, which every screen that needs booking terminology
// already fetches (Bookings.jsx's `industry` state, Sidebar.jsx's
// `userData`, Navbar.jsx's `vendorProfileData`).
export const getBookingLabel = (industryProfile, plural = false) => {
  const cfg = industryProfile?.label_config;
  const key = plural ? "bookingPlural" : "bookingSingular";
  return cfg?.[key] || (plural ? "Bookings" : "Booking");
};
